module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/cassete-75ae71c221ef8f414f8740bcc6f127b0.svg";